<template>
    <div>
        <navbar></navbar>
        <div class="container"> 
            <p class="__somep">Projects</p>
            <p class="__absom">Some of our projects</p>
            <p class="__abproduct1">Our clientele comprises some of the most progressive companies across the globe. We work with businesses spanning different sectors but having the same desire - the need for great tech. We listen to our clients and with distinctive collaboration, transform their big ideas into exceptional products.<br>We work with the best and deliver the best, such that when your product launches, you are guaranteed two things - smiles and satisfaction.</p>
            <p class="__abproduct1">Send us a mail at <a href="mailto:info@findworka.com" class="__sendmess"> info@findworka.com</a> to say hello and can also <router-link to="/build" class="__sendmess">begin a project</router-link> with us.</p>
        </div>
        <div class="container">
			<div class="row">
				<div v-for="(project,i) in projects" :key="`${i}`">
					<div class="col-lg-6 col-md-6 col-sm-6">
						<button class="__findbtn" @click="findProject(project.slug)" style="">
							<div class="__meetd">
								<figure class="effect">
									<img :src="project.bannerImage" class="__climg">
									<figcaption class="__figcaption">
										<p class="__meetdname">{{ project.name }}</p>
										<p class="__dept">{{ project.tasks }}</p>
										<p class="__soci">{{ project.shortDescription }}</p>
										<p class="__a">Learn More &nbsp;<span><i class="fas fa-arrow-right shake"></i></span></p>
									</figcaption>			
								</figure>
							</div>
						</button>
					</div>
				</div>
			</div>
		</div>

        <div class="__stbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-md-5 col-sm-5">
                        <p class="__wwd">Start Project</p>
                        <p class="__fbuild">We know how much your idea means to you. What we do is take those ideas and convert them to world-class software products.</p>
                        <router-link to="/build" class="btn __startp">Start Project</router-link>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-7"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import navbar from "../components/navbar";
	import loadProjects from '../assets/js/projects.json'

	export default {
        components: { navbar },
		name:'projects',
		data(){
			return {
				projects: '',
			}
		},
		mounted(){
			this.projects = loadProjects
		},
		methods: {
			findProject(slug){
				let array = this.projects
				for (let i=0; i < array.length; i++) {
					if (array[i].slug === slug) {
						this.$store.state.found = i
						console.log(this.$store.state.found)
					}
				this.$router.push('/portfolio')
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/css/project';
</style>


// WEBPACK FOOTER //
// src/components/project.vue